<template>
  <div class="cd-skeleton-wrapper">
    <div class="cd-container">
      <div class="cd-layout">
        <!-- Sidebar (Solda) -->
        <div class="cd-sidebar">
          <div class="cd-skeleton-card cd-sk-trailer">
            <div class="cd-skeleton cd-skeleton--img"></div>
            <div class="cd-sk-trailer-actions">
              <div class="cd-skeleton cd-sk-btn"></div>
              <div class="cd-skeleton cd-sk-btn"></div>
              <div class="cd-skeleton cd-sk-btn"></div>
              <div class="cd-skeleton cd-sk-btn"></div>
            </div>
          </div>
        </div>

        <!-- Main Content (Sağda) -->
        <div class="cd-main">
          <div class="cd-skeleton-card cd-sk-header-card">
            <div class="cd-skeleton cd-sk-title"></div>
            <div class="cd-sk-meta-row">
              <div class="cd-skeleton cd-sk-meta"></div>
              <div class="cd-skeleton cd-sk-meta cd-sk-meta--long"></div>
            </div>
          </div>

          <div class="cd-sk-tab-wrap">
            <div class="cd-skeleton cd-sk-tab"></div>
          </div>

          <div class="cd-skeleton-card cd-sk-content-card">
            <div class="cd-sk-content-head">
              <div class="cd-skeleton cd-sk-section-title"></div>
            </div>

            <div v-for="n in 5" :key="'cd-row-'+n" class="cd-sk-row">
              <div class="cd-skeleton cd-sk-row-title"></div>
              <div class="cd-skeleton cd-sk-row-action"></div>
            </div>
          </div>

          <div class="cd-skeleton-card cd-sk-accordion">
            <div class="cd-sk-accordion-head">
              <div class="cd-skeleton cd-sk-accordion-title"></div>
              <div class="cd-skeleton cd-sk-accordion-arrow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile: trailer skeleton en üstte görünsün -->
    <div class="cd-mobile-trailer">
      <div class="cd-skeleton-card cd-sk-trailer">
        <div class="cd-skeleton cd-skeleton--img"></div>
        <div class="cd-sk-trailer-actions">
          <div class="cd-skeleton cd-sk-btn"></div>
          <div class="cd-skeleton cd-sk-btn"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollectionDetailSkeleton"
};
</script>

<style scoped>
/* ── Shimmer ── */
@keyframes cd-shimmer {
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}

.cd-skeleton {
  background: linear-gradient(90deg, #eceef2 25%, #f7f8fb 50%, #eceef2 75%);
  background-size: 800px 100%;
  animation: cd-shimmer 1.35s infinite ease-in-out;
}

.cd-skeleton--img {
  width: 100%;
  aspect-ratio: 16 / 9;
}

.cd-skeleton-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  overflow: hidden;
}

/* ── Header card ── */
.cd-sk-header-card {
  padding: 24px 24px 18px;
  margin-bottom: 16px;
}

.cd-sk-title {
  height: 36px;
  width: min(380px, 72%);
  border-radius: 9px;
}

.cd-sk-meta-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.cd-sk-meta {
  height: 13px;
  width: 165px;
  border-radius: 6px;
}

.cd-sk-meta--long {
  width: 205px;
}

/* ── Tab ── */
.cd-sk-tab-wrap {
  margin-bottom: 14px;
}

.cd-sk-tab {
  height: 40px;
  width: 128px;
  border-radius: 999px;
}

/* ── Content list ── */
.cd-sk-content-card {
  padding: 0;
}

.cd-sk-content-head {
  padding: 16px 20px;
}

.cd-sk-section-title {
  height: 20px;
  width: 140px;
  border-radius: 8px;
}

.cd-sk-row {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 16px;
  border-top: 1px solid #eef0f3;
}

.cd-sk-row-title {
  height: 16px;
  width: min(460px, 72%);
  border-radius: 6px;
}

.cd-sk-row-action {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  flex-shrink: 0;
}

/* ── Accordion ── */
.cd-sk-accordion {
  margin-top: 20px;
  padding: 0 18px;
}

.cd-sk-accordion-head {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cd-sk-accordion-title {
  width: 170px;
  height: 20px;
  border-radius: 8px;
}

.cd-sk-accordion-arrow {
  width: 18px;
  height: 18px;
  border-radius: 50%;
}

/* ── Trailer sidebar ── */
.cd-sk-trailer-actions {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cd-sk-btn {
  height: 42px;
  border-radius: 10px;
}

/* ── Layout (parent ile aynı) ── */
.cd-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 20px;
}

.cd-layout {
  display: flex;
  gap: 32px;
}

.cd-sidebar {
  width: 360px;
  flex-shrink: 0;
  align-self: flex-start;
}

.cd-main {
  flex: 1;
  min-width: 0;
}

.cd-mobile-trailer {
  display: none;
}

/* ── Mobil ── */
@media (max-width: 768px) {
  .cd-mobile-trailer {
    display: block;
    margin: 12px;
  }

  .cd-container {
    padding: 16px 12px;
  }

  .cd-layout {
    flex-direction: column;
    gap: 16px;
  }

  .cd-sidebar {
    display: none;
  }

  .cd-sk-header-card {
    padding: 18px 16px 14px;
    margin-bottom: 12px;
  }

  .cd-sk-title {
    width: 88%;
    height: 30px;
  }

  .cd-sk-meta {
    width: 128px;
  }

  .cd-sk-meta--long {
    width: 146px;
  }

  .cd-sk-tab {
    width: 112px;
    height: 36px;
  }

  .cd-sk-row-title {
    width: 66%;
  }

  .cd-sk-row-action {
    width: 34px;
    height: 34px;
  }
}
</style>
